"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.VolumeControl = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
require("rc-slider/assets/index.css");
var _MediaPlayer = require("../../constants/MediaPlayer");
var _PermissionTooltip = _interopRequireDefault(require("../Permissions/PermissionTooltip"));
var _VolumeControl = require("./VolumeControl.styled");
var VolumeControl = exports.VolumeControl = function VolumeControl(_ref) {
  var id = _ref.id,
    _onClick = _ref.onClick,
    enableFeature = _ref.enableFeature,
    onVolumeChanged = _ref.onVolumeChanged,
    _ref$volume = _ref.volume,
    volume = _ref$volume === void 0 ? _MediaPlayer.MediaPlayer.volume : _ref$volume;
  var scale = 100;
  // truncating this to prevent large float number being displayed in volume metre
  var currentVolume = (volume * scale).toFixed(0);
  var handleChange = function handleChange(value) {
    onVolumeChanged(value / scale);
  };
  var displayPermissionTooltip = function displayPermissionTooltip(targetElementId) {
    return _react["default"].createElement(_PermissionTooltip["default"], {
      displayTooltip: !enableFeature,
      targetElementId: targetElementId,
      requiredRole: 'Contributor, admin or show caller'
    });
  };
  var targetElementId = 'volume-control-wrapper';
  return _react["default"].createElement(_VolumeControl.StyledPermissionWrapper, {
    enableFeature: enableFeature
  }, _react["default"].createElement(_VolumeControl.VolumeControlWrapper, {
    id: targetElementId,
    onClick: function onClick(e) {
      e.stopPropagation();
      if (_onClick && enableFeature) _onClick();
    }
  }, _react["default"].createElement(_VolumeControl.StyledSlider, {
    id: "volumeSlider_".concat(id),
    vertical: true,
    step: 1,
    startPoint: 0,
    value: currentVolume,
    defaultValue: currentVolume,
    onChange: enableFeature ? handleChange : function () {}
  }), _react["default"].createElement(_VolumeControl.StyledOutput, {
    htmlFor: "volumeSlider_".concat(id)
  }, currentVolume), displayPermissionTooltip(targetElementId)));
};
VolumeControl.propTypes = {
  live: _propTypes["default"].bool,
  onClick: _propTypes["default"].func,
  // Only used for the purpose of testing
  isAudioSource: _propTypes["default"].bool,
  enableFeature: _propTypes["default"].bool,
  id: _propTypes["default"].string.isRequired,
  muted: _propTypes["default"].bool.isRequired,
  volume: _propTypes["default"].number.isRequired,
  onVolumeChanged: _propTypes["default"].func.isRequired
};